<script setup>
import { ref } from 'vue';
const userList = ref([
  {
    url: require("../../assets/images/web/shzx.png"),
    name: "上海市第三中学",
    bgColor: '#65F9B8'
  },
  {
    url: require("../../assets/images/web/bd.png"),
    name: "百度",
    bgColor: '#FFBD6F'

  },
  {
    url: require("../../assets/images/web/fsk.png"),
    name: "富士康",
    bgColor: '#FFE55F'

  },
  {
    url: require("../../assets/images/web/xuehua.png"),
    name: "雪花啤酒",
    bgColor: '#A6FC63'
  },
])
</script>

<template>
  <div class="user-serve-box">
    <img src="../../assets/images/web/slider_5.png" alt="">
    <div class="user">
      <div class="title">
        · TalkAI服务用户 ·
        <img src="../../assets/images/web/user_line.png" alt="">
      </div>
      <div class="user-item-box">
        <div class="item" v-for="item in userList" :style="{ backgroundColor: item.bgColor }">
          <img :src="item.url" class="user-img">
          {{ item.name }}
        </div>
      </div>
      <div class="serve-text">
        · 服务合作联系方式 ·
      </div>
      <div class="contact">
        官方联系合作邮箱：amazingcompany@163.com
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.user-serve-box {
  background-color: #f6f6f6;
  padding-left: 35px;
  padding-top: 212px;
  display: flex;
  align-items: center;

  .user {
    margin-left: 76px;
    margin: 0 auto;

    .title {
      font-size: 32px;
      font-weight: 600;
      line-height: 50px;
      text-align: center;
      position: relative;

      img {
        position: absolute;
        left: 52%;
        top: -40px;
        width: 380px;
        height: 120px;
        transform: translateX(-50%);
      }
    }

    .user-item-box {
      display: flex;
      justify-content: space-around;
      margin-top: 144px;

      .item {
        position: relative;
        height: 100px;
        line-height: 100px;
        width: max-content;
        padding: 0 70px;
        border-radius: 24px;
        transform: skewX(-20deg);
        font-family: "YouSheBiaoTiHei";
        font-size: 32px;
        font-weight: 400;
        text-align: center;
        margin-right: 40px;


        .user-img {
          position: absolute;
          top: -40px;
          right: 24px;
          width: 64px;
          height: 64px;
          transform: skewX(20deg);

        }
      }
    }
    .serve-text {
      text-align: center;
font-size: 14px;
font-weight: 500;
line-height: 50px;
margin-top: 145px;

    }
    .contact {
      margin: auto;
      height: 32px;
      padding: 0 16px;
      line-height: 32px;
      width: max-content;
      font-size: 12px;
      font-weight: 500;
      color: #0E1F00;
      background-color: #D3FF99;
      border: 1.5px solid #fff;
      border-radius: 85px;
      margin-bottom: 66px;
    }

  }
}
</style>